import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { SECTOR_GROUPS } from '../data/homeMenus';

export const IndustriesExpertise = () => {
  return (
    <section className="py-24 bg-white" data-testid="industries-expertise">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-4 uppercase tracking-wide">
            Capital Expertise Across <span className="text-emerald-600">Industries</span>
          </h2>
          <p className="text-lg text-slate-600">
            Financing structures differ across industries. Our approach considers sector economics, operating cycles, asset profiles, cash flows and lender appetite when evaluating capital requirements.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {SECTOR_GROUPS.map((group) => (
            <div
              key={group.name}
              className="bg-white rounded-xl border-2 border-slate-200 hover:border-emerald-500 hover:shadow-xl transition-all duration-300 p-6"
              data-testid={`sector-group-${group.name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
            >
              <h3 className="text-base font-bold text-emerald-700 mb-4">{group.name}</h3>
              <ul className="space-y-2">
                {group.items.map(([label, to]) => (
                  <li key={to}>
                    <Link
                      to={to}
                      className="group flex items-start gap-1.5 text-sm text-slate-600 hover:text-emerald-600 transition-colors"
                    >
                      <ArrowRight className="w-3.5 h-3.5 mt-0.5 flex-shrink-0 text-slate-300 group-hover:text-emerald-500 transition-colors" />
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/industries"
            className="inline-flex items-center gap-2 text-emerald-700 font-semibold hover:gap-3 transition-all"
            data-testid="view-all-industries-link"
          >
            View All Industries <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};
